module.exports = __webpack_public_path__ + "img/Wp_2020.1f85ecfd.png";